import React, { useMemo, useState } from 'react';
import type { AssetGsiItem } from '@/app/api/incidents/asset-gsi.types';
import { GsiTrendChart as GsiTrendChartView, PERIOD_MONTHS, Period } from '@/components/composite/GsiTrendChart';
import { aggregateWeeklyGsi } from '@/components/pages/SituationalAwareness/components/utils/incidentGsi';
import { useTranslations } from '@/core/translations';
import styles from './GsiTrendChart.module.scss';

interface GsiTrendChartProps {
  data: AssetGsiItem[];
}

export const GsiTrendChart: React.FC<GsiTrendChartProps> = ({ data: rawData }) => {
  const t = useTranslations('incidents_page.assets_card');
  const [period, setPeriod] = useState<Period>(Period.M3);

  const points = useMemo(() => aggregateWeeklyGsi(rawData, PERIOD_MONTHS[period]), [rawData, period]);

  return (
    <GsiTrendChartView
      className={styles.root}
      points={points}
      title={t('gsi_trend')}
      subtitle={t('gsi_trend_subtitle', { months: PERIOD_MONTHS[period] })}
      defaultPeriod={Period.M3}
      onPeriodChange={setPeriod}
    />
  );
};
